import { Helmet } from "react-helmet-async";
import { Button, Dropdown, CustomInput, Layout, CustomSearch, TableRowResponsive, DatePickerInput, Input, PersianMap, Timeline, StyledContainer, StepperItem, CustomModal } from "../../components";
import { UniversalController } from "../../controllers";
import { connect } from "react-redux";
import { ArrowBack, Arrowdown2, Arrowleft, Calendar3, DangerSquare, Download, Forward, Import, Money, ReplyPic, User, Cancel } from "../../../assets";
import { Accordion, AccordionDetails, AccordionSummary, Box, Checkbox, FormControlLabel, Pagination, PaginationItem, Slide, Tab, Tabs, } from "@mui/material";
import styled from "@emotion/styled";
import { Line } from "react-chartjs-2";
import { numberWithCommas } from "../../../core/utils";
import { AppConstants } from "../../../core/constants";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import routes from "../../../core/routes";
import { toast } from "react-toastify";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React from "react";
import { TransitionProps } from "@mui/material/transitions";
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import moment from "moment-jalaali";


const BorderLinearProgress = styled(LinearProgress)(({ theme }: any) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#155a9e' : '#308fe8',
    },
}));

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});
class Universal extends UniversalController {
    async componentDidMount() {
        const pathParts = window.location.pathname.split("/");

        const promises = [];

        if (pathParts[1] === "universal-update") {
            promises.push(this.getDefaultInquery());
        } else {
            promises.push(this.getLimitationInquery())


        }

        await Promise.all(promises);
        this.setState({ loading: false });

    }
    render() {
        const { value, step, showInfo,
            openMenu,


            jobListInquiry, jobListHolderLoading, projectDetails, loading, jobListHolder, jobListInquiryLoading, currentPage, result, premium_annually, adjustment_coefficient_death_benefit, start_death_asset, errors,
            contract_id,
            base64Loading,
            settings,
            tabValue,
            doucument,
            step1Errors
        } = this.state;
        return (
            <Layout title=" مسکن متری  ">
                <Helmet>
                    <title>  مسکن متری   | بیمه زندگی هامرز </title>
                </Helmet>
                {loading ?
                    <LinearProgress />
                    :

                    <>
                        {
                            step === 1 &&
                            <>
                                <div className="universal scrollbar">

                                    <div className="universal-details ">

                                        <div className="universal-details-section column-1 ">
                                            <span className="universal-details-title mt-0">
                                                {projectDetails?.title}                            </span>
                                            <span className="building-use mt-1"> {projectDetails?.address} </span>
                                            {/* <span className="project-progress"> سرمایه گذاری :
                    
                     <span className="percent  me-2">{numberWithCommas((projectDetails?.available_price * value).toFixed(0))} درصد</span></span> */}
                                            <div className="universal-details-section  hide-desktop">
                                                {doucument?.project_media?.length > 0 && (
                                                    <Slider {...settings}>
                                                        {doucument?.project_media?.map((item: any, index: number) => (
                                                            <img src={`${AppConstants.base_core_url}${item?.attachments}`} alt="هامرز" className="maskan-img" />
                                                        ))}
                                                    </Slider>
                                                )}
                                                <span className="universal-details-title">
                                                    توضیحات پروژه
                                                </span>

                                                <p className="universal-details-description">
                                                    {projectDetails?.descritpion}                                  </p>
                                            </div>

                                            <div className="item">
                                                <span className="item-title">   متراژ کل :</span>
                                                <span className="item-value">{projectDetails?.units_all} {projectDetails?.unit}</span>
                                            </div>
                                            <div className="item">
                                                <span className="item-title">متراژ باقی مانده:</span>
                                                <span className="item-value">{projectDetails?.available_quantity}  {projectDetails?.unit}</span>
                                            </div>
                                            <div className="item">
                                                <span className="item-title">
                                                    قیمت اولیه هر متر
                                                    <img
                                                        src={DangerSquare}
                                                        alt="هامرز"
                                                        style={{ cursor: "pointer", marginRight: "2px", marginLeft: "2px" }}
                                                        onClick={() => this.handleOpenModal('قیمت اولیه هر متر', 'قیمتی که در ابتدای پروژه برای هر مترمربع تعیین شده است.')}
                                                    />
                                                    :   </span>
                                                <span className="item-value">{numberWithCommas(projectDetails?.basic_price_meter)}  ریال </span>
                                            </div>
                                            <div className="item">
                                                <span className="item-title">
                                                    قیمت روز هر متر  <img
                                                        src={DangerSquare}
                                                        alt="هامرز"
                                                        style={{ cursor: "pointer", marginRight: "2px", marginLeft: "2px" }}
                                                        onClick={() => this.handleOpenModal('قیمت روز هر متر', 'قیمت فعلی هر متر در پروژه، با توجه به شرایط بازار و پیشرفت ساخت‌وساز به‌روزرسانی می‌شود.')}
                                                    />   :   </span>
                                                <span className="item-value"> {numberWithCommas(projectDetails?.available_price)} ریال </span>
                                            </div>
                                            <div className="item">
                                                <span className="item-title">  سود محقق شده   <img
                                                    src={DangerSquare}
                                                    alt="هامرز"
                                                    style={{ cursor: "pointer", marginRight: "2px", marginLeft: "2px" }}
                                                    onClick={() => this.handleOpenModal('سود محقق شده', 'نشان‌دهنده درصد افزایش قیمت هر متر نسبت به قیمت اولیه است.')}
                                                />   :   </span>
                                                <span className="item-value"> {numberWithCommas(projectDetails?.efficiency)} درصد </span>
                                            </div>
                                            <div className="item">
                                                <span className="item-title">  مبلغ سرمایه گذاری
                                                    <img
                                                        src={DangerSquare}
                                                        alt="هامرز"
                                                        style={{ cursor: "pointer", marginRight: "2px", marginLeft: "2px" }}
                                                        onClick={() => this.handleOpenModal('مبلغ سرمایه گذاری', 'مبلغ سرمایه‌گذاری، همان مبلغی است که برای متراژ انتخابی خود در پروژه پرداخت می‌کنید. سقف این مبلغ بر اساس قیمت روز هر متر و مقدار متراژی که هنوز در پروژه باقی مانده، تعیین می‌شود.')}
                                                    /> :
                                                </span>
                                                <div className="meterage-input">
                                                    <input
                                                        className="my-input"
                                                        type="text"
                                                        name="investmentAmount"
                                                        // min={0.1 * projectDetails?.available_price}
                                                        max={projectDetails?.available_quantity * projectDetails?.available_price}
                                                        value={numberWithCommas(premium_annually)}
                                                        onChange={(e) => this.handleInvestmentChange(e.target.value.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString()).replace(/,/g, ''))}
                                                        // onBlur={this.handleInvestmentBlur}
                                                        dir="ltr"
                                                    />
                                                    <span className="unit">ریال</span>
                                                </div>
                                                {step1Errors?.filter((name: { path: string; }) => name.path === "premium_annually")?.[0]?.errors?.[0] &&

                                                    <label className="custom-input-error">
                                                        {step1Errors?.filter((name: { path: string; }) => name.path === "premium_annually")?.[0]?.errors?.[0]}
                                                    </label>

                                                }
                                            </div>
                                            <div className="item">
                                                <span className="item-title">  متراژ مورد درخواست
                                                    <img
                                                        src={DangerSquare}
                                                        alt="هامرز"
                                                        style={{ cursor: "pointer", marginRight: "2px", marginLeft: "2px" }}
                                                        onClick={() => this.handleOpenModal('متراژ مورد درخواست', 'بیمه‌گذار می‌تواند با توجه به بودجه خود، حداقل ۰.۱ متر از پروژه را برای سرمایه‌گذاری انتخاب کند. این انعطاف‌پذیری به شما امکان می‌دهد با هر میزان سرمایه، در پروژه مشارکت داشته باشید .')}
                                                    /> :
                                                </span>
                                                <div className="meterage-input">
                                                    <input
                                                        className="my-input"
                                                        type="text"
                                                        name="number"
                                                        // min="0.1"
                                                        max={projectDetails?.available_quantity}
                                                        value={value}
                                                        onChange={(e) => this.handleMeterageChange(e.target.value.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString()))}
                                                        // onBlur={this.handleMeterageBlur}
                                                        dir="ltr"
                                                    />
                                                    <span className="unit">متر</span>
                                                </div>
                                                {step1Errors?.filter((name: { path: string; }) => name.path === "value")?.[0]?.errors?.[0] &&

                                                    <label className="custom-input-error">
                                                        {step1Errors?.filter((name: { path: string; }) => name.path === "value")?.[0]?.errors?.[0]}
                                                    </label>

                                                }
                                            </div>


                                            <div className="building-progress-bar">
                                                <div className="building-progress-bar-headline">
                                                    <span className="title">  شروع پروژه : <span className="value"> {projectDetails?.start_date && moment(`${projectDetails?.start_date}`, 'YYYY-M-D').format('jYYYY/jM/jD')} </span></span>
                                                    <span className="title">  اتمام پروژه : <span className="value"> {projectDetails?.end_date && moment(`${projectDetails?.end_date}`, 'YYYY-M-D').format('jYYYY/jM/jD')} </span></span>

                                                </div>
                                                <BorderLinearProgress variant="determinate" value={this.calculateDateProgress(projectDetails?.start_date, projectDetails?.end_date)} />


                                            </div>
                                            {/* <div className="item">
                                <span className="item-title">حداقل میزان سرمایه گذاری:</span>
                                <span className="item-value">0.1 متر مربع (معادل یک آژور یا 10 سانتی متر)</span>
                            </div> */}

                                            <div className="item flex-column align-items-start">
                                                <div className="item-meterage ">
                                                    <div className="accordion-container">
                                                        <Accordion className="faq-accordion">
                                                            <AccordionSummary
                                                                expandIcon={<img alt="هامرز" src={Arrowdown2} />}
                                                                aria-controls="panel1a-content"
                                                                className="accordion-summary"
                                                                id="panel1a-header"
                                                            >
                                                                <span className="accordion-title">برای وارد کردن شماره قرارداد کلیک کنید</span>
                                                            </AccordionSummary>
                                                            <AccordionDetails
                                                                className="summsry"
                                                            >
                                                                <div className="contract-id ">
                                                                    <span className="item-secend">شماره قرارداد :</span>

                                                                    <Input
                                                                        max="10"
                                                                        disabled={window.location.pathname.split("/")[1] === "universal-update"}
                                                                        lable=""
                                                                        hideEndAdornment
                                                                        type="number"
                                                                        endAdornment=""
                                                                        myStyle=""
                                                                        value={contract_id}
                                                                        onChange={(e: any) => this.setState({ contract_id: e })}
                                                                    />
                                                                </div>

                                                            </AccordionDetails>
                                                        </Accordion>
                                                    </div>
                                                </div>
                                            </div>


                                            <div>
                                                <Button myStyle="bg-light-blue select-btn mt-3" title="ادامه خرید " onClick={() => this.checkStep2()} />
                                                <PersianMap myStyle="mt-2" latitude={projectDetails?.latitude} longitude={projectDetails?.longitude} />

                                            </div>

                                            {/* <div className="item">
                                <span className="item-title">مبلغ قابل پرداخت:</span>
                                <span className="item-value"> {numberWithCommas(projectDetails?.available_price * value)}  ریال</span>
                                <span className="item-value"> {numberWithCommas((projectDetails?.available_price * value).toFixed(0))}  ریال</span>

                            </div> */}

                                        </div>
                                        <div className="universal-details-section column-2 ">
                                            <div className=" hide-mobile">
                                                {doucument?.project_media?.length > 0 && (

                                                    <Slider {...settings} >
                                                        {doucument?.project_media?.map((item: any, index: number) => (
                                                            <img src={`${AppConstants.base_core_url}${item?.attachments}`} alt="هامرز" className="maskan-img" />

                                                        ))}
                                                    </Slider>
                                                )}
                                            </div>

                                            <div className="tabs-container" style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                                                <Tabs
                                                    value={tabValue}
                                                    onChange={this.handleChange}
                                                    aria-label="wrapped label tabs"
                                                    textColor="primary"
                                                    indicatorColor="primary"
                                                    variant="scrollable"
                                                    scrollButtons="auto"
                                                >
                                                    <Tab label=" امکانات پروژه " />
                                                    <Tab label="برنامه زمانی" />
                                                    <Tab label="توضیحات پروژه" />
                                                    <Tab label=" سازنده " />
                                                    <Tab label=" مستندات " />

                                                </Tabs>
                                                <Box sx={{ padding: 3 }}>
                                                    {tabValue === 0 && <div className="facilities">
                                                        {projectDetails?.project_facilities?.map((item: any, index: number) => (
                                                            <div className="" key={item?.id}>
                                                                <span className="facilities-title"> <img className="ms-1" src={`${AppConstants.base_core_url}${item.icon_image}`} alt="هامرز" /> {item?.name} </span>
                                                            </div>
                                                        ))}


                                                    </div>}

                                                    {tabValue === 1 && <div><Timeline data={projectDetails?.time_line} /></div>}
                                                    {tabValue === 2 && <div><StyledContainer title="عمومی">
                                                        <>{projectDetails?.general_description}</>
                                                    </StyledContainer>

                                                        <StyledContainer title="اختصاصی" >
                                                            <>{projectDetails?.private_description}</>
                                                        </StyledContainer></div>}

                                                    {tabValue === 3 && <div>



                                                        {doucument?.project_builder?.map((item: any, index: number) => (
                                                            <div className="builder-info-container" key={index}>
                                                                <div className="builder-info-header">
                                                                    <div className="builder-name">
                                                                        <span className="label">نام سازنده:</span>
                                                                        <span className="value">{item?.manager_name}</span>
                                                                    </div>
                                                                    <div className="builder-manager">
                                                                        <span className="label">نام شرکت:</span>
                                                                        <span className="value">{item?.name}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="builder-description">
                                                                    <span className="label">توضیحات:</span>
                                                                    <span className="value">{item?.description}</span>
                                                                </div>
                                                                {item?.link && (
                                                                    <div className="builder-download">
                                                                        <div className="site-label">
                                                                            <span className="label">سایت:</span>
                                                                            <a
                                                                                href={item?.link}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                className="site-link"
                                                                            >
                                                                                <span className="value">{item?.link}</span>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}




                                                    </div>}
                                                    {tabValue === 4 && <div> {doucument?.project_reports?.map((item: any, index: number) => (
                                                        <>

                                                            <div className="item">
                                                                <span className="item-title"> {item?.descr} :</span>
                                                                <span className="item-value cursor-pointer"
                                                                    onClick={() =>
                                                                        window.open(
                                                                            `${AppConstants.base_core_url}${item?.attachments}`,
                                                                            '_blank'
                                                                        )
                                                                    }>                  دانلود   <img src={Download} alt="هامرز" /> </span>
                                                            </div>

                                                        </>))}</div>}

                                                </Box>
                                            </div>
                                            {/* <span className="universal-details-title">
                                توضیحات پروژه
                            </span>

                            <p className="universal-details-description">
                                {projectDetails?.descritpion}                            </p> */}
                                        </div>
                                    </div>
                                </div>
                                <CustomModal myStyle="custom-input-modal" openModal={this.state.openModal} onClose={this.handleCloseModal}>
                                    <>
                                        <div className="custom-modal-main-title hide-desktop">
                                            <h1 className="title">
                                                {this.state.modalLabel}              </h1>
                                            <Cancel myStyle="ps-2 " width="20" height="20" color="#000000" onClick={this.handleCloseModal} />
                                        </div>
                                        <div className="filter-selected">
                                            <div>
                                                <span className="text ml-50 hide-mobile bold">
                                                    {this.state.modalLabel}
                                                </span>{" "}
                                            </div>
                                            <Cancel myStyle="hide-mobile cursor-pointer" onClick={this.handleCloseModal} />
                                        </div>

                                        <h2 className="custom-input-modal-info mt-33">
                                            {this.state.modalNotice}
                                        </h2>
                                    </>
                                </CustomModal>
                            </>

                        }

                        {
                            step === 2 &&

                            <div className="inquery  scrollbar">
                                <div className="inquery-container ">

                                    <div className="inquery-stepper hide-mobile">
                                        <div className="stepper-container">
                                            <StepperItem stepTitle="مرحله اول" stepDesc=" اطلاعات پایه    " step={2} activeStep={step} />
                                            <StepperItem stepTitle="مرحله دوم" stepDesc=" مشاهده نتیجه استعلام " step={3} activeStep={step} />
                                        </div>
                                    </div>
                                    <div className="inquery-content">
                                        {/* <div>
                                <span className="inquery-title">
                                    اطلاعات تکمیلی                                                    </span>
                                <p className="inquery-description">
                                    اطلاعات زیر را جهت استعلام بیمه نامه تکمیل نمایید.                                                    </p>
                            </div> */}


                                        <div className="inquery-form ">

                                            <span className="inquery-section-title">
                                                اطلاعات هویتی بیمه گذار
                                            </span>
                                            <div className="row-container ">
                                                <div className="w-48">
                                                    <DatePickerInput
                                                        iconBorder
                                                        ref={this.datePickerRefHolder}
                                                        // contentLoading={contentLoading}
                                                        // emptyState={() => this.setState({ holder_birthday: "" })}
                                                        //  disabled
                                                        error={errors.filter((name: { path: string; }) => name.path === "holder_birthday")?.[0]?.errors?.[0]}
                                                        value={this.state.holder_birthday}
                                                        onChange={this.handleChangeHolderBD}
                                                        isRequired hideEndAdornment
                                                        calendarPosition="bottom-right"
                                                        containerClassName="date-picker-container w-100"
                                                        inputClass="date-picker-input"
                                                        myStyle="inquery-input mb-0"
                                                        lable="تاریخ تولد"
                                                        icon={<img src={Calendar3} alt="هامرز" />}
                                                        maxDate={new DateObject({ calendar: persian }).subtract(18, "years")}

                                                    />

                                                </div>
                                                {/* <Dropdown objectList error={step1Errors.filter((name: { path: string; }) => name.path === "policy_holder_job_category")?.[0]?.errors?.[0]} items={jobListHolder}  displayEmpty myStyle="inquery-dropdown 
                                                        onChange={(event: any) => this.changeJobHolder(event.target.value)} icon={<img src={User} />} /> */}
                                                <CustomSearch hasNotice="درصورت داشتن چندین شغل خواهشمند است شغلی که عمده درآمد خود را از آن کسب می‌کنید، انتخاب نمایید." loading={jobListHolderLoading} error={errors.filter((name: { path: string; }) => name.path === "policy_holder_job_category")?.[0]?.errors?.[0]} iconBorder icon={<img src={User} alt="هامرز" />} lable="شغل  " isRequired search={(e: any) => this.getJobHolder(e)} value={this.state.policy_holder_job_category} title={this.state.policy_holder_job_category_title} item={jobListHolder} myStyle="w-48" placeholder="انتخاب کنید" onChange={(event: any) => this.changeJobHolder(event)} />

                                            </div>
                                            <div className="title-check-container">

                                                <>
                                                    <span className="inquery-section-title">
                                                        اطلاعات هویتی بیمه شده
                                                    </span>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox checked={this.state.selfsame} onChange={(e: any) => this.selfsame(e)} name="selfsame" sx={{
                                                                // color: "#155a9e",
                                                                borderRadius: "3px",
                                                                width: "23px",
                                                                height: "23px",
                                                                '&.Mui-checked': {
                                                                    // color: "#155a9e",
                                                                    borderRadius: "3px",
                                                                    width: "23px",
                                                                    height: "23px",
                                                                },
                                                                '&.MuiCheckbox-root': {
                                                                    padding: 0
                                                                }
                                                            }} />
                                                        }
                                                        label="بیمه گذار و بیمه شده یک شخص واحد می باشد."
                                                    />

                                                </>


                                            </div>
                                            <div className="row-container ">
                                                <div className="w-48">
                                                    <DatePickerInput
                                                        ref={this.datePickerRefInsured}
                                                        iconBorder

                                                        // contentLoading={contentLoading}
                                                        // emptyState={() => this.setState({ insured_birthday: "" })}

                                                        error={errors.filter((name: { path: string; }) => name.path === "insured_birthday")?.[0]?.errors?.[0]}
                                                        value={this.state.insured_birthday}
                                                        onChange={this.handleChangeInsuredBD}
                                                        calendarPosition="bottom-right"
                                                        containerClassName="date-picker-container w-100"
                                                        inputClass="date-picker-input"
                                                        isRequired hideEndAdornment
                                                        myStyle="inquery-input w-100"
                                                        lable="تاریخ تولد"
                                                        icon={<img src={Calendar3} alt="هامرز" />}
                                                        maxDate={new DateObject({
                                                            calendar: persian,
                                                        })}
                                                    />

                                                </div>
                                                <CustomSearch hasNotice="درصورت داشتن چندین شغل خواهشمند است شغلی که عمده درآمد خود را از آن کسب می‌کنید، انتخاب نمایید." loading={jobListInquiryLoading} error={errors.filter((name: { path: string; }) => name.path === "insured_job_category")?.[0]?.errors?.[0]} iconBorder icon={<img src={User} alt="هامرز" />} lable="شغل  " isRequired search={(e: any) => this.getJobInquiry(e)} value={this.state.insured_job_category} title={this.state.insured_job_category_title} item={jobListInquiry} myStyle="w-48" placeholder="انتخاب کنید" onChange={(event: any) => this.changeJobInsured(event)} />
                                                {/* <Dropdown objectList error={step1Errors.filter((name: { path: string; }) => name.path === "insured_job_category")?.[0]?.errors?.[0]} items={jobListInquiry} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-30"  placeholder="  انتخاب کنید " value={this.state.insured_job_category}
                                                        onChange={(event: any) => this.changeJobInsured(event.target.value)}
                                                        icon={<img src={User} alt="هامرز" />} /> */}

                                            </div>
                                            <span className="inquery-section-title">
                                                پوشش های بیمه شده
                                            </span>
                                            <div className="row-container ">
                                                <CustomInput disabled hasComma error={errors.filter((name: { path: string; }) => name.path === "start_death_asset")?.[0]?.errors?.[0]} hideEndAdornment isRequired type="number" endAdornment="ریال" iconBorder icon={<Money />} myStyle="inquery-input w-48" lable="سرمایه فوت به هر علت " value={start_death_asset} />
                                                <Dropdown hasNotice="شما می‌توانید با انتخاب هر یک از درصدهای زیر ، میزان سرمایه فوت خود را به صورت سالانه افزایش دهید." items={this.state.limitationInquiry?.filter((item: { name: string; }) => item.name === "adjustment_coefficient_death_benefit")[0]?.values} error={errors.filter((name: { path: string; }) => name.path === "adjustment_coefficient_death_benefit")?.[0]?.errors?.[0]} isRequired iconBorder displayEmpty myStyle="inquery-dropdown w-48" lable="افزایش سالانه سرمایه فوت  (درصد) " placeholder="  انتخاب کنید " value={adjustment_coefficient_death_benefit} onChange={(e: any) => this.setState({ adjustment_coefficient_death_benefit: e.target.value })} icon={<Money />} />

                                                {/* <Dropdown error={errors.filter((name: { path: string; }) => name.path === "adjustment_coefficient_death_benefit")?.[0]?.errors?.[0]} iconBorder icon={<Money />} isRequired objectList items={limitationInquiry?.filter((item: { name: string; }) => item.name === "adjustment_coefficient_death_benefit")[0]?.values}  displayEmpty myStyle="inquery-dropdown w-48 custom-dropdown" lable="افزایش سالانه سرمایه فوت " placeholder="  انتخاب کنید " value={adjustment_coefficient_death_benefit} onChange={(e: any) => this.setState({ adjustment_coefficient_death_benefit: e })} /> */}



                                            </div>
                                        </div>

                                        <div className="inquery-btn-group">
                                            {/* {contentLoading ? <>
                                        <div className="content-loading"></div>
                                        <div className="content-loading"></div>
                                    </> : */}
                                            <>
                                                <Button myStyle="bg-light-blue next-btn" title="استعلام" onClick={() => this.checkForm()} />
                                                <Button myStyle="bg-outline-white pre-btn" title="مرحله قبل" onClick={() => this.setState({ step: 1 })} />
                                            </>
                                            {/* } */}
                                        </div>


                                    </div>

                                </div>
                            </div>

                        }

                        {
                            step === 3 &&
                            <>
                                <div className="inquery scrollbar h-100 " >
                                    <div className="inquery-container   hide-mobile">
                                        <div className={openMenu ? "drawer-menu-container inquery-stepper" : "inquery-drawer"} onClick={() => this.setState({ openMenu: !openMenu })}>
                                            {openMenu &&
                                                <div className="stepper-container">
                                                    <StepperItem latestStep="cursor-pointer" onClick={() => this.setState({ step: 2 })} stepTitle="مرحله اول" stepDesc="  اطلاعات پایه  " step={2} activeStep={step} />
                                                    <StepperItem latestStep="cursor-pointer" onClick={() => this.setState({ step: 3 })} stepTitle="مرحله دوم" stepDesc=" مشاهده نتیجه استعلام " step={3} activeStep={step} />
                                                </div>
                                            }
                                            <div className={`${openMenu ? "left" : "position-fixed"} inquery-circle-menu`} ><Arrowleft myStyle={openMenu ? "rotate-180" : ""} color="#ffffff" /></div>
                                        </div>
                                        <div className="inquery-result-container">
                                            <div className="inquery-result">
                                                <div className="inquery-result-data">

                                                    <div className="info justify-content-between">
                                                        <div className="w-100">
                                                            <div className="out-side ">

                                                                <span className="  data-title">
                                                                    استعلام حق بیمه
                                                                </span>
                                                                {/* <div className="out-side-data-item data-item">
                                                        <span className="title ">
                                                            مدت بیمه نامه
                                                        </span>
                                                        <span className="description primary-title">
                                                            1 سال
                                                        </span>

                                                    </div>
                                                    <div className="out-side-data-item data-item">
                                                        <span className="title ">
                                                            نحوه پرداخت حق بیمه
                                                        </span>
                                                        <span className="description primary-title">
                                                            تست
                                                        </span>

                                                    </div>
                                                    <div className="out-side-data-item data-item">
                                                            <>
                                                                <span className="title ">
                                                                    مدت پرداخت حق بیمه
                                                                </span>
                                                                <span className="description primary-title">
                                                                    342 سال
                                                                </span>
                                                            </>
                                                    </div> */}
                                                            </div>

                                                            <div className="data-items">
                                                                <div className="data-item">
                                                                    <span className="title">
                                                                        حق بیمه پرداختی
                                                                    </span>
                                                                    <span className="description">
                                                                        {/* {numberWithCommas(premium_annually)} */}
                                                                        {numberWithCommas(result?.result?.slice(currentPage * 5, currentPage * 5 + 5)[0]?.pre_total_paid)}
                                                                        {" "} ریال
                                                                    </span>

                                                                </div>
                                                                <div className="data-item">
                                                                    <span className="title">
                                                                        متراژ انتخابی                                                         </span>
                                                                    <span className="description">
                                                                        {value}     متر                                                    </span>

                                                                </div>



                                                                <div className="data-item">
                                                                    <span className="title">
                                                                        سرمایه فوت به هر علت
                                                                    </span>
                                                                    <span className="description">
                                                                        {numberWithCommas(this.state.start_death_asset)} ریال
                                                                    </span>


                                                                </div>

                                                                <div className="data-item">
                                                                    <span className="title">
                                                                        افزایش سالانه سرمایه فوت                                                         </span>
                                                                    <span className="description">
                                                                        {this.state.adjustment_coefficient_death_benefit} درصد
                                                                    </span>

                                                                </div>

                                                                <div className="data-item">
                                                                    <span className="title">
                                                                        قیمت  عرضه هر متر                                                          </span>
                                                                    <span className="description">
                                                                        {numberWithCommas(projectDetails?.available_price)} ریال
                                                                    </span>

                                                                </div>
                                                                <div className="data-item">
                                                                </div>

                                                            </div>
                                                        </div>

                                                        {/* <div className="info-chart">
                                            <div className="info-chart-headline">
                                                <span className="title">
                                                    رشد اندوخته
                                                </span>

                                                <div className="d-flex">
                                                    <div className="roshd">
                                                        <span className="roshd-badge t"></span>
                                                        <span className="roshd-title">  رشد تضمینی (ریال)</span>

                                                    </div>
                                                    <div className="roshd me-3">
                                                        <span className="roshd-badge p"></span>
                                                        <span className="roshd-title">  رشد پیش بینی شده (ریال)</span>

                                                    </div>
                                                </div>
                                            </div>


                                            <Line
                                                data={this.state.data}

                                                options={this.state.options}
                                            />
                                        </div> */}
                                                    </div>

                                                </div>


                                                {/* <div className="inquery-result-chart"> */}
                                            </div>
                                            <div className="policy w-100 table-responsive mt-2">
                                                <table className="table hide-mobile">
                                                    <thead>
                                                        <tr>

                                                            <th scope="col">سال</th>
                                                            <th scope="col">سن </th>
                                                            <th scope="col">حق بیمه  یکجا</th>
                                                            <th scope="col"> سرمایه فوت (به هر علت) </th>

                                                            <th scope="col">بازخریدی (تضمینی) </th>
                                                            <th scope="col">بازخریدی (پیشبینی) </th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {result?.result?.slice(currentPage * 5, currentPage * 5 + 5)
                                                            ?.map((item: any, index: number) => (

                                                                // {result?.map((item: any, index: number) => {
                                                                //     return (
                                                                <tr>
                                                                    <th dir="ltr">{item?.term_year}</th>
                                                                    <th dir="ltr">{item?.age}</th>
                                                                    <th dir="ltr">{numberWithCommas(item?.pre_total_paid)}</th>
                                                                    <th dir="ltr">{numberWithCommas(item?.death_benefit)}</th>

                                                                    <th dir="ltr">{numberWithCommas(item?.pre_investment)}</th>
                                                                    <th dir="ltr">{numberWithCommas(item?.pre_investment)}</th>
                                                                </tr>
                                                            )
                                                            )}
                                                    </tbody>
                                                </table>


                                                <div className="d-flex justify-content-between w-100">
                                                    <div className="d-flex">
                                                        {result?.universal_offer ?
                                                            <Button myStyle="bg-green next-btn" title="ثبت پیشنهاد بیمه نامه" link={window.location.pathname.split("/")[1] === "universal-update" ? `${routes?.UNIVERALISSUING}/${window.location.pathname.split("/")[2]}` : routes.UNIVERALISSUING} />
                                                            :
                                                            <Button myStyle="bg-green next-btn" title="ثبت پیشنهاد بیمه نامه" onClick={() => toast.error("با توجه به منفی شدن ارزش بازخرید , خواهشمند است نسبت به افزایش حق بیمه یا کاهش تعهدات اقدام فرمایید . ")} />


                                                        }
                                                        <Button loading={base64Loading} icon={Import} myStyle="replay bg-light-blue next-btn loading-spinner-primary " title="چاپ جدول تعهدات" onClick={() => this.downloadPdf()} />
                                                    </div>

                                                    <Pagination
                                                        className="custom-pagination "
                                                        count={result?.result ? Math.ceil(result?.result?.length / 5) : 1}
                                                        onChange={this.handleChangePage}
                                                        size="small"
                                                        page={currentPage + 1}
                                                        renderItem={(item) => (
                                                            <PaginationItem
                                                                slots={{ previous: Forward, next: ArrowBack }}
                                                                {...item}
                                                            />
                                                        )}
                                                    />



                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className=" inquery hide-desktop ">
                                        {step === 3 &&
                                            <>

                                                <div className="inquery-tab">


                                                    <div className={`${this.state.tab === 1 ? "inquery-tab-item-active" : ""} inquery-tab-item`}>

                                                        <div className={`${this.state.tab === 1 ? "tab-active" : "tab-deactive"} tab-style`} onClick={() => this.setState({ tab: 1 })}>
                                                            جدول پرداخت حق بیمه
                                                        </div>
                                                        {this.state.tab === 1 &&
                                                            <span className="up-arrow"></span>
                                                        }
                                                    </div>

                                                    <div className={`${this.state.tab === 0 ? "inquery-tab-item-active" : ""} inquery-tab-item`}>
                                                        <div className={`${this.state.tab === 0 ? "tab-active" : "tab-deactive"} tab-style`} onClick={() => this.setState({ tab: 0 })}>
                                                            استعلام حق بیمه

                                                        </div>
                                                        {this.state.tab === 0 &&
                                                            <span className="up-arrow"></span>
                                                        }
                                                    </div>


                                                </div>

                                                <div className="inquery-result-container scrollbar">

                                                    {this.state.tab === 0 ?
                                                        <div className="inquery-result">
                                                            <div className="inquery-result-data">
                                                                <div className={`${showInfo ? "data-accordion-expand" : "data-accordion"} data-items `}>

                                                                    <div className="data-item">
                                                                        <span className="title ">
                                                                            حق بیمه پرداختی
                                                                        </span>
                                                                        <span className="description">
                                                                            {numberWithCommas(result?.result?.slice(currentPage * 5, currentPage * 5 + 5)[0]?.pre_total_paid)}
                                                                            ریال
                                                                        </span>
                                                                    </div>
                                                                    <div className="data-item">
                                                                        <span className="title">
                                                                            متراژ انتخابی
                                                                        </span>
                                                                        <span className="description">
                                                                            {value} متر
                                                                        </span>
                                                                    </div>



                                                                    <div className="data-item">
                                                                        <span className="title">
                                                                            سرمایه فوت به هر علت
                                                                        </span>
                                                                        <span className="description">
                                                                            {numberWithCommas(start_death_asset)} ریال
                                                                        </span>

                                                                    </div>


                                                                    <div className="data-item">
                                                                        <span className="title ">
                                                                            افزایش سالانه سرمایه فوت
                                                                        </span>
                                                                        <span className="description">
                                                                            {this.state.adjustment_coefficient_death_benefit} درصد
                                                                        </span>

                                                                    </div>




                                                                    <div className="data-item">
                                                                        <span className="title">
                                                                            قیمت عرضه هر متر                                                      </span>
                                                                        <span className="description">
                                                                            {numberWithCommas(projectDetails?.available_price)} ریال
                                                                        </span>

                                                                    </div>
                                                                    <div className="data-item">

                                                                    </div>

                                                                </div>
                                                            </div>
                                                            {/* <div className="inquery-result-chart"> */}
                                                            {/* <div className="info-chart mt-2">
                                            <div className="info-chart-headline">
                                            <div className="info-chart-headline-download">
                                             <span className="title">

                                                    رشد اندوخته
                                                </span>
                                                <Button loading={base64Loading} icon={Import} myStyle="replay bg-light-blue next-btn loading-spinner-primary " title="چاپ جدول تعهدات" onClick={() => this.downloadPdf()} />
                                                </div>

                                                <div className="d-flex">
                                                    <div className="roshd">
                                                        <span className="roshd-badge t"></span>
                                                        <span className="roshd-title">  رشد تضمینی  (ریال)</span>

                                                    </div>
                                                    <div className="roshd me-3">
                                                        <span className="roshd-badge p"></span>
                                                        <span className="roshd-title"> رشد پیش بینی شده (ریال)</span>

                                                    </div>
                                                </div>
                                            </div>
                                            <Line
                                                data={this.state.data}
                                                options={this.state.options}

                                            />
                                        </div> */}
                                                        </div>
                                                        :
                                                        <div className="policy w-100 table-responsive mt-2">
                                                            <div>

                                                                {result?.result?.slice(currentPage * 5, currentPage * 5 + 5)?.map((item: any, index: number) => {
                                                                    return (
                                                                        <Accordion className="policy-accordion hide-desktop">
                                                                            <AccordionSummary
                                                                                expandIcon={<img src={Arrowdown2} alt="هامرز" />}
                                                                                aria-controls="panel1a-content"
                                                                                className="summsry"
                                                                                id="panel1a-header"
                                                                            >

                                                                                <TableRowResponsive title="سال" value={item?.term_year} />
                                                                                <TableRowResponsive title="سن" value={item?.age} />
                                                                                <TableRowResponsive title="حق بیمه  یکجا" value={numberWithCommas(item?.pre_total_paid)} />
                                                                            </AccordionSummary>
                                                                            <AccordionDetails
                                                                                className="d-flex flex-wrap"
                                                                            >
                                                                                <TableRowResponsive title=" سرمایه فوت به هر علت" value={numberWithCommas(item?.death_benefit)} />
                                                                                <TableRowResponsive title="بازخریدی (تضمینی)" value={numberWithCommas(item?.pre_investment)} />

                                                                                <TableRowResponsive title=" بازخریدی (پیشبینی) " value={numberWithCommas(item?.pre_investment)} />

                                                                            </AccordionDetails>

                                                                        </Accordion>
                                                                    )
                                                                })}
                                                            </div>
                                                            <Pagination
                                                                className="custom-pagination mt-3"
                                                                count={result?.result ? Math.ceil(result?.result?.length / 5) : 1}
                                                                onChange={this.handleChangePage}
                                                                size="small"
                                                                page={currentPage + 1}
                                                                renderItem={(item) => (
                                                                    <PaginationItem
                                                                        slots={{ previous: Forward, next: ArrowBack }}
                                                                        {...item}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                                <div className="Inquery-result-btn-group inquery-btn-group">
                                                    {result?.universal_offer ?
                                                        <Button icon={ReplyPic} myStyle="replay bg-green next-btn" title="ثبت پیشنهاد بیمه نامه" link={window.location.pathname.split("/")[1] === "universal-update" ? `${routes?.UNIVERALISSUING}/${window.location.pathname.split("/")[2]}` : routes.UNIVERALISSUING} />

                                                        :
                                                        <Button icon={ReplyPic} myStyle="replay bg-green next-btn" title="ثبت پیشنهاد بیمه نامه" onClick={() => toast.error("با توجه به منفی شدن ارزش بازخرید , خواهشمند است نسبت به افزایش حق بیمه یا کاهش تعهدات اقدام فرمایید . ")} />


                                                    }
                                                    {/* <div className="user-dashboard" onClick={() => this.setState({ showUpdateMOdal: !showUpdateMOdal })} >

                                    ویرایش بیمه نامه    
                                </div> */}
                                                </div>
                                            </>
                                        }


                                    </div>

                                </div>
                            </>
                        }

                    </>
                }
            </Layout>
        )
    }
}

const mapStateToProps = (dispatch: any) => {
    return {
        dispatch,
        userData: dispatch.general.userData,
    };
};
export default connect(mapStateToProps)(Universal);
